(function(window, $){

  const $animateElements = $('[animation-container]');

  $(window).on('scroll', handleWindowScroll);

  if (location.hash) {
    setTimeout(function() {

      window.scrollTo(0, 0);
      const scrollTop = $(location.hash).offset().top ;
      const scrollSpeed = scrollTop / $(window).height() * 100 * 2;
      $('body, html').animate({scrollTop}, scrollSpeed);
    }, 1);
  }


  function handleWindowScroll(evt){
    const top = $(window).scrollTop();
    console.log('WINDOW scroll', top);

    $animateElements.each(function(){
      const offset = window.matchMedia("(max-width: 768px)").matches ?
          50 :
          parseInt($(this).height() /3);
      const elemTop = $(this).offset().top - $(window).height();
      if (elemTop + offset < top) {
        animateSectionIn($(this));
      }
    })
  }

  function animateSectionIn($elem){
    if (!$elem.hasClass('animate-in')) {
      $elem.addClass('animate-in');

      if ($elem.find('[data-count-to]').length > 0) {
        const countMax = 35;
        let count = 0;

        const interval = setInterval(() => {
          if (count++ >= countMax) {
            clearInterval(interval);
            return true;
          }

          $elem.find('[data-count-to]').each(function () {
            const countTo = parseFloat($(this).data('count-to').toString().replace(/,/g, ''));
            $(this).text(formatNumber(parseInt(countTo / countMax * count), $(this).data('after-text'), $(this).data('before-text'), $(this).data('number-separator')));
          })
        }, 20);
      }
    }
  }

  function formatNumber(num, postString = '', preString = '', numDelimeter = ',') {
    return (preString || '') + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, numDelimeter) + (postString || '');
  }

  $(document).ready(() => handleWindowScroll())

})(window, window.jQuery);
